export default function sequentialProgress(game, events) {
  const answers = events.filter((event) => event.kind === 'select').map(({ item_id, selected_id }) => ({ item_id, selected_id }));
  const help = Number(events.some((event) => event.kind === 'help_prompt'));
  let cursor = 0, attempts = 0, wrong = 0, first = 0;
  const assessments = [];
  answers.forEach((answer) => {
    const item = game.items[cursor];
    attempts += 1;
    const mechanic = item?.mechanic || game.assessment_mode;
    const stones = item?.stones || item?.items?.[0]?.stones;
    const construction = stones && ['syllable_train', 'word_construction', 'syllable_bridge', 'word_repair'].includes(mechanic);
    const ids = construction ? answer.selected_id.split(',') : [];
    let text = construction ? ids.map((id) => {
      const stone = stones.find((entry) => entry.id === id);
      return stone?.text ?? stone?.letter ?? '';
    }).join('') : answer.selected_id;
    if (mechanic === 'word_repair') text = item.prefix + text + item.suffix;
    if (item && text === item.expected_id && (!construction || new Set(ids).size === ids.length)) {
      first += Number(attempts === 1);
      assessments.push({ item_id: item.id, skill_key: item.skill_key, first_try_correct: Number(attempts === 1),
        total_assessments: 1, wrong_selection_count: attempts - 1 });
      cursor += 1; attempts = 0;
    } else wrong += 1;
  });
  const completed = cursor === game.items.length;
  return { answers, completed, summary: { game_id: game.game_id, completed, first_try_correct: first,
    total_assessments: game.items.length, wrong_selection_count: wrong, ...(game.unmeasured_help ? {} : { help_count: help }),
    measurement_type: game.measurement_type, assessments } };
}
